// A-S7b: the inline quick-customer forms (OpportunityForm, NoteForm, ActivityForm, contactForm) bind
// customer.email; the server reads only mainEmail. Copy it across when mainEmail is empty.
export function withMainEmail(customer) {
  const email = customer && typeof customer.email === 'string' ? customer.email.trim() : ''
  if (customer && !customer.mainEmail && email) return { ...customer, mainEmail: email }
  return customer
}
